import { FilterTypes } from "@plura/shared/lead-forms";

export type FilterCategory = { label: string; value: FilterTypes, description: string; isTemplate?: boolean }

export const filterGroups: {
  title: string;
  options: FilterCategory[]
}[] = [
    {
      title: 'Goals',
      options: [
        {
          label: 'Collect Feedback',
          value: 'get-feedback',
          description: 'Collect meaningful, honest feedback through forms that feel simple, friendly, and worth completing.',
        },
        {
          label: 'Sales',
          value: 'make-sales',
          description: 'Increase conversions with sales-focused templates made to help you close more deals—without extra effort.',
        },
        {
          label: 'Organize Events',
          value: 'plan-events',
          description: 'From planning to post-event wrap-ups, these templates help you organize every detail and deliver a standout experience.',
        },
        {
          label: 'Connect with People',
          value: 'engage-audience',
          description: 'Entertain your audience with interactive quizzes, tests, and experiences that keep people clicking.',
        },
        {
          label: 'Capture Leads',
          value: 'lead-generation',
          description: 'Turn visitors into warm leads with conversational forms and quizzes that feel more like a chat than a form.',
        },
      ],
    },
    {
      title: 'Teams',
      options: [
        {
          label: 'Sales',
          value: 'sales',
          description: 'Boost your pipeline with forms designed to convert more prospects into paying customers.',
          isTemplate: true,
        },
        {
          label: 'Product',
          value: 'product',
          description: 'Understand your users better with templates built for product insights, feature feedback, and discovery.',
          isTemplate: true,
        },
        {
          label: 'Marketing',
          value: 'marketing',
          description: 'Grow your audience and reach more customers using these high-impact marketing form templates.',
          isTemplate: true,
        },
        {
          label: 'HR & Recruiting',
          value: 'human-resources',
          description: 'Support your team and simplify internal workflows with these easy-to-use HR templates.',
          isTemplate: true,
        },
        {
          label: 'Client Success',
          value: 'customer-success',
          description: 'Keep customers happy and engaged with templates that help you understand their needs and measure satisfaction.',
          isTemplate: true,
        },
      ],
    }
  ]
